import moment from "moment";
import {
  LEAD_DETAILS,
  LEAD_DETAILS_ERROR,
  UPDATE_LEAD_DETAILS,
  SAVE_CLIENT_NOTE,
  SAVE_CLIENT_NOTE_ERROR,
  LEAD_NOTES,
  LEAD_NOTES_ERROR,
  LEAD_REMARKS,
  LEAD_REMARKS_ERROR,
  LEAD_NOTE_DETAIL,
  LEAD_NOTE_DETAIL_ERROR,
  LEAD_REMARK_DETAIL,
  LEAD_REMARK_DETAIL_ERROR,
  SAVE_CLIENT_REMARKS,
  SAVE_CLIENT_REMARKS_ERROR,
  LEAD_EMPTY_ERROR_OBJ,
  DELETE_LEAD_NOTE,
  DELETE_LEAD_NOTE_ERROR,
  DELETE_LEAD_REMARKS,
  DELETE_LEAD_REMARKS_ERROR,
  LEAD_TASKS_STATUS_LIST,
  LEAD_TASKS_STATUS_LIST_ERROR,
  LEAD_REMARK_CHIPS,
  LEAD_REMARK_CHIPS_ERROR,
  CREATED_LEAD_DETAILS,
  EMAIL_CONVERSATION_HISTORY,
  LOADING,
  UNREAD_NOTIFICATIONS,
  NOTES_TAGS,
  LEAD_HISTORY,
} from "../actionType/leadDetailsType";
import {
  deleteAuthMethod,
  getAuthMethod,
  getMethod,
  postAuthMethod,
  putAuthMethod,
} from "../services/HttpServices";
import {
  getClientLeadsUrl,
  saveClientNoteApiUrl,
  getClientNotesApiUrl,
  getClientRemarksApiUrl,
  getLeadTasksStatusApiUrl,
  emailConversationHistory,
  receiveEmailUrl,
  markAsReadUrl,
  allTags,
  clientLeadsUrl,
  // getLeadNoteDetails
} from "../constant/Constant";
import { ErrKey, errEnum } from "../config";
import {
  createActivityPayload,
  createActivityPayloadForRemarks,
} from "../utils/utils";

export const getLeadDetails = (id) => (dispatch) => {
  const url = `${getClientLeadsUrl}/${id}`;
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: LEAD_DETAILS,
        payload: res?.data,
      });
      return res;
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: LEAD_DETAILS_ERROR,
        payload:
          { [errEnum.LEAD_DETAILS_ERROR]: err.response.data[ErrKey] } ||
          "Error Occured",
      });
    });
};

export const updateLeadDetails = (payload, isUpdate) => (dispatch) => {
  if (isUpdate) {
    return putAuthMethod(getClientLeadsUrl, payload.id, payload)
      .then((res) => {
        res.data.stepsbar = payload?.stepsbar ? payload?.stepsbar : false;
        dispatch({
          type: UPDATE_LEAD_DETAILS,
          payload: res?.data,
        });
        dispatch(getLeadDetails(payload.id));
        return res?.data;
      })
      .catch((err) => {
        return err;
      });
  } else {
    return postAuthMethod(getClientLeadsUrl, payload)
      .then((res) => {
        dispatch({
          type: CREATED_LEAD_DETAILS,
          payload: res?.data,
        });
        return res?.data;
      })
      .catch((err) => {
        return err;
      });
  }
};

export const submitLeadNotes = (payload) => (dispatch) => {
  if (payload.update) {
    return putAuthMethod(saveClientNoteApiUrl, payload.id, payload)
      .then((res) => {
        dispatch({
          type: SAVE_CLIENT_NOTE,
          payload: res.data,
        });
        dispatch(getAllLeadNotes(payload?.lead?.id));
        return res;
      })
      .catch((err) => {
        if (!err?.response?.data) return err;
        dispatch({
          type: SAVE_CLIENT_NOTE_ERROR,
          payload:
            {
              [errEnum.SAVE_CLIENT_NOTE_ERROR]: err.response.data,
            } || "Error Occured",
        });
        return err;
      });
  } else {
    return postAuthMethod(saveClientNoteApiUrl, payload)
      .then((res) => {
        dispatch({
          type: SAVE_CLIENT_NOTE,
          payload: res.data,
        });
        dispatch(getAllLeadNotes(payload?.lead?.id));
        return res.data;
      })
      .catch((err) => {
        if (!err?.response?.data) return err;
        dispatch({
          type: SAVE_CLIENT_NOTE_ERROR,
          payload:
            {
              [errEnum.SAVE_CLIENT_NOTE_ERROR]: err.response.data,
            } || "Error Occured",
        });
        return err;
      });
  }
};

export const resetSubmitLeadNotes = (payload) => {
  return { type: SAVE_CLIENT_NOTE, payload: {} };
};

export const deleteLeadNote = (id, leadId) => (dispatch) => {
  return deleteAuthMethod(`${saveClientNoteApiUrl}/${id}`)
    .then((res) => {
      dispatch({
        type: DELETE_LEAD_NOTE,
        payload: res.data,
      });
      dispatch(getAllLeadNotes(leadId));
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: DELETE_LEAD_NOTE_ERROR,
        payload:
          {
            [errEnum.DELETE_LEAD_NOTE_ERROR]: err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const getAllLeadNotes =
  (id, payload = {}) =>
  (dispatch) => {
    dispatch({
      type: LOADING,
      payload: true,
    });
    let apiUrl = `${getClientNotesApiUrl}?leadId.equals=${id}`;
    const url = createActivityPayload(payload, apiUrl);
    return getAuthMethod(url)
      .then((res) => {
        dispatch({
          type: LEAD_NOTES,
          payload: res?.data,
        });
        dispatch({
          type: LOADING,
          payload: false,
        });
      })
      .catch((err) => {
        dispatch({
          type: LOADING,
          payload: false,
        });
        if (!err?.response?.data) return;
        dispatch({
          type: LEAD_NOTES_ERROR,
          payload:
            { [errEnum.LEAD_NOTES_ERROR]: err.response.data[ErrKey] } ||
            "Error Occured",
        });
      });
  };

export const getLeadNoteDetails = (id) => (dispatch) => {
  const url = `${getClientNotesApiUrl}/${id}`;
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: LEAD_NOTE_DETAIL,
        payload: res?.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: LEAD_NOTE_DETAIL_ERROR,
        payload:
          { [errEnum.LEAD_NOTE_DETAIL_ERROR]: err.response.data[ErrKey] } ||
          "Error Occured",
      });
    });
};

export const resetLeadNoteDetails = (id) => (dispatch) => {
  dispatch({
    type: LEAD_NOTE_DETAIL,
    payload: {},
  });
};

export const getAllLeadRemarks =
  (id, payload = {}) =>
  (dispatch) => {
    let apiUrl = `${getClientRemarksApiUrl}?leadId.equals=${id}`;
    const url = createActivityPayloadForRemarks(payload, apiUrl);
    return getAuthMethod(url)
      .then((res) => {
        dispatch({
          type: LEAD_REMARKS,
          payload: res?.data,
        });
      })
      .catch((err) => {
        if (!err?.response?.data) return;
        dispatch({
          type: LEAD_REMARKS_ERROR,
          payload:
            { [errEnum.LEAD_REMARKS_ERROR]: err.response.data[ErrKey] } ||
            "Error Occured",
        });
      });
  };

export const submitLeadRemarks = (payload) => (dispatch) => {
  const formattedPayload = {
    ...payload,
    ...(payload?.interactionDate
      ? {
          interactionDate:
            typeof payload.interactionDate === "object" &&
            typeof payload.interactionDate.toISOString === "function"
              ? payload.interactionDate.toISOString()
              : moment(payload.interactionDate).isValid()
              ? moment(payload.interactionDate).toISOString()
              : payload.interactionDate,
        }
      : {}),
  };
  if (formattedPayload.update) {
    return putAuthMethod(getClientRemarksApiUrl, formattedPayload.id, formattedPayload)
      .then((res) => {
        dispatch({
          type: SAVE_CLIENT_REMARKS,
          payload: res.data,
        });
        dispatch(getAllLeadRemarks(formattedPayload?.lead?.id));
      })
      .catch((err) => {
        if (!err?.response?.data) return;
        dispatch({
          type: SAVE_CLIENT_REMARKS_ERROR,
          payload:
            {
              [errEnum.SAVE_CLIENT_REMARKS_ERROR]: err.response.data,
            } || "Error Occured",
        });
      });
  } else {
    return postAuthMethod(getClientRemarksApiUrl, formattedPayload)
      .then((res) => {
        dispatch({
          type: SAVE_CLIENT_REMARKS,
          payload: res.data,
        });
        dispatch(getAllLeadRemarks(formattedPayload?.lead?.id));
      })
      .catch((err) => {
        if (!err?.response?.data) return;
        dispatch({
          type: SAVE_CLIENT_REMARKS_ERROR,
          payload:
            {
              [errEnum.SAVE_CLIENT_REMARKS_ERROR]: err.response.data,
            } || "Error Occured",
        });
      });
  }
};

export const resetSubmitLeadRemarkss = (payload) => {
  return { type: SAVE_CLIENT_REMARKS, payload: {} };
};

export const getLeadRemarksDetails = (id) => (dispatch) => {
  const url = `${getClientRemarksApiUrl}/${id}`;
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: LEAD_REMARK_DETAIL,
        payload: res?.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: LEAD_REMARK_DETAIL_ERROR,
        payload:
          { [errEnum.LEAD_REMARK_DETAIL_ERROR]: err.response.data[ErrKey] } ||
          "Error Occured",
      });
    });
};

export const deleteLeadRemarks = (id, leadId) => (dispatch) => {
  return deleteAuthMethod(`${getClientRemarksApiUrl}/${id}`)
    .then((res) => {
      dispatch({
        type: DELETE_LEAD_REMARKS,
        payload: res.data,
      });
      dispatch(getAllLeadRemarks(leadId));
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: DELETE_LEAD_REMARKS_ERROR,
        payload:
          {
            [errEnum.DELETE_LEAD_REMARKS_ERROR]: err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const emptyErrorObj = () => ({
  type: LEAD_EMPTY_ERROR_OBJ,
  payload: {},
});

export const getLeadTasksStatusList = (payload) => (dispatch) => {
  return getAuthMethod(getLeadTasksStatusApiUrl)
    .then((res) => {
      dispatch({
        type: LEAD_TASKS_STATUS_LIST,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: LEAD_TASKS_STATUS_LIST_ERROR,
        payload:
          {
            [errEnum.LEAD_TASKS_STATUS_LIST_ERROR]: err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const getLeadRemarkChips =
  ({ type, status } = {}) =>
  (dispatch) => {
    if (!type || !status) {
      dispatch({
        type: LEAD_REMARK_CHIPS,
        payload: [],
      });
      return Promise.resolve([]);
    }

    const url = `${getClientRemarksApiUrl}/chips?type=${encodeURIComponent(
      type,
    )}&status=${encodeURIComponent(status)}`;

    return getAuthMethod(url)
      .then((res) => {
        const chips = Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res?.data?.content)
            ? res.data.content
            : Array.isArray(res?.data?.chips)
              ? res.data.chips
              : [];

        dispatch({
          type: LEAD_REMARK_CHIPS,
          payload: chips,
        });

        return chips;
      })
      .catch((err) => {
        dispatch({
          type: LEAD_REMARK_CHIPS,
          payload: [],
        });

        if (!err?.response?.data) return err;
        dispatch({
          type: LEAD_REMARK_CHIPS_ERROR,
          payload:
            {
              [errEnum.LEAD_REMARK_CHIPS_ERROR]: err.response.data[ErrKey],
            } || "Error Occured",
        });
        return err;
      });
  };

export const resetLeadUpdatedInfo = () => ({
  type: UPDATE_LEAD_DETAILS,
  payload: {},
});
export const resetLeadCreatedInfo = () => ({
  type: CREATED_LEAD_DETAILS,
  payload: {},
});

export const getEmailHistoryByLeadId = (id) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return getAuthMethod(`${emailConversationHistory}/${id}`)
    .then((res) => {
      dispatch({
        type: EMAIL_CONVERSATION_HISTORY,
        payload: res.data,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const getEmailHistory = (id) => (dispatch) => {
  return getAuthMethod(`${emailConversationHistory}/${id}`)
    .then((res) => {
      dispatch({
        type: EMAIL_CONVERSATION_HISTORY,
        payload: res.data,
      });
    })
    .catch((err) => {
      return err;
    });
};

export const deleteEmail = (id, clientId) => (dispatch) => {
  return deleteAuthMethod(`${emailConversationHistory}/${id}`)
    .then((res) => {
      dispatch(getEmailHistoryByLeadId(clientId));
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const receiveEmail = (leadId) => (dispatch) => {
  return postAuthMethod(`${receiveEmailUrl}`)
    .then((res) => {
      dispatch({
        type: UNREAD_NOTIFICATIONS,
        payload: res?.data || [],
      });
      const clientLeadId = parseInt(leadId);
      const notiClientIds = res?.data?.map((d) => d?.clientLeadId);
      const isUnread = notiClientIds.includes(clientLeadId);
      if (clientLeadId && isUnread) {
        dispatch(getEmailHistory(clientLeadId));
        dispatch(markAsRead(clientLeadId));
      }
      return res.data;
    })
    .catch((err) => {
      return err;
    });
};

export const markAsRead = (leadId) => {
  return async (dispatch) => {
    try {
      await postAuthMethod(`${markAsReadUrl}?clientLeadId=${leadId}`);
    } catch (error) {}
  };
};

export const getClientNotesTags = (userId) => (dispatch) => {
  const url = `${allTags}?type.equals=NOTE${userId ? `&userId.equals=${userId}` : ""}`;
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: NOTES_TAGS,
        payload: res?.data?.tagsDTOs,
      });
    })
    .catch((err) => {
      return err;
    });
};

const normalizeLeadHistoryResponse = (response, page = 0, size = 10) => {
  const data = response?.data;
  const headerTotalCount =
    Number(
      response?.headers?.["x-total-count"] ?? response?.headers?.["X-Total-Count"],
    ) || 0;

  if (Array.isArray(data)) {
    return {
      content: data,
      totalElements: headerTotalCount || data.length,
      totalPages: Math.ceil((headerTotalCount || data.length) / (size || 1)) || 0,
      number: page,
      size,
    };
  }

  const content = data?.content || [];
  const normalizedSize = data?.size || size;
  const totalElements =
    headerTotalCount || data?.totalElements || data?.count || content.length;

  return {
    ...data,
    content,
    totalElements,
    totalPages:
      data?.totalPages ?? (Math.ceil(totalElements / (normalizedSize || 1)) || 0),
    number: data?.number ?? page,
    size: normalizedSize,
  };
};

export const getLeadHistory =
  (id, params = {}) =>
  (dispatch) => {
    const page = params?.page ?? 0;
    const size = params?.size ?? 10;
    const sort = params?.sort || "createdDate,desc";
    const searchTerm = params?.searchTerm?.trim();
    const fieldFilter = params?.fieldFilter?.trim();
    const url = `${clientLeadsUrl}/${id}/history?page=${page}&size=${size}&sort=${sort}${
      searchTerm ? `&searchTerm=${encodeURIComponent(searchTerm)}` : ""
    }${fieldFilter ? `&fieldFilter=${encodeURIComponent(fieldFilter)}` : ""}`;
    return getAuthMethod(url)
      .then((res) => {
        const normalizedPayload = normalizeLeadHistoryResponse(res, page, size);
        dispatch({
          type: LEAD_HISTORY,
          payload: normalizedPayload,
        });
        return normalizedPayload;
      })
      .catch((err) => {
        return err;
      });
  };
